import { ArrowUpRight, FolderOpen } from "lucide-react";

export default function GalleryLinks({ links = [], compact = false }) {
  return (
    <div className={`grid grid-cols-2 ${compact ? "md:grid-cols-4 gap-2 mt-4" : "md:grid-cols-4 gap-4 mt-10"}`}>
      {(links || []).map((l) => {
        const ready = !!l.url;
        return (
          <a
            key={l.key}
            href={ready ? l.url : undefined}
            target="_blank"
            rel="noreferrer"
            data-testid={`gallery-link-${l.key}`}
            aria-disabled={!ready}
            className={`group relative border border-white/10 bg-[#121212] ${compact ? "p-4" : "p-6 md:p-8"} flex flex-col justify-between ${compact ? "min-h-[90px]" : "min-h-[160px]"} transition-[border-color,background-color] duration-150 ${ready ? "hover:border-[#FF5A00] hover:bg-[#FF5A00]/10 cursor-pointer" : "opacity-50 cursor-not-allowed"}`}
          >
            <FolderOpen className="w-5 h-5 text-[#FF5A00]" />
            <div className="flex items-end justify-between gap-2">
              <div>
                <p className={`font-display font-black uppercase italic leading-none ${compact ? "text-xl sm:text-2xl" : "text-3xl md:text-4xl"}`}>{l.label}</p>
                <p className="text-xs text-neutral-400">{ready ? "Buka Google Drive" : "Segera tersedia"}</p>
              </div>
              {ready && <ArrowUpRight className="w-6 h-6 shrink-0 transition-transform duration-150 group-hover:-translate-y-1 group-hover:translate-x-1" />}
            </div>
          </a>
        );
      })}
    </div>
  );
}
